// Kitchen staples — pre-selected by default, user can deselect if they don't have them
export const STAPLES = [
  { id: 'staple_salt',       emoji: '🧂', label: 'Salt',          cat: 'staples', staple: true },
  { id: 'staple_pepper',     emoji: '⚫', label: 'Black Pepper',  cat: 'staples', staple: true },
  { id: 'staple_butter',     emoji: '🧈', label: 'Butter',        cat: 'staples', staple: true },
  { id: 'staple_olive_oil',  emoji: '🫒', label: 'Olive Oil',     cat: 'staples', staple: true },
  { id: 'staple_garlic',     emoji: '🧄', label: 'Garlic',        cat: 'staples', staple: true },
  { id: 'staple_milk',       emoji: '🥛', label: 'Milk',          cat: 'staples', staple: true },
  { id: 'staple_sugar',      emoji: '🍬', label: 'Sugar',         cat: 'staples', staple: true },
  { id: 'staple_flour',      emoji: '🌾', label: 'Flour',         cat: 'staples', staple: true },
  { id: 'staple_eggs',       emoji: '🥚', label: 'Eggs',          cat: 'staples', staple: true },
  { id: 'staple_vinegar',    emoji: '🍶', label: 'Vinegar',       cat: 'staples', staple: true },
  { id: 'staple_baking_soda', emoji: '⚪', label: 'Baking Soda',   cat: 'staples', staple: true },
  { id: 'staple_baking_powder', emoji: '⚪', label: 'Baking Powder', cat: 'staples', staple: true },
];

// src/data/ingredients.js
// Master ingredient list. Add/remove items here to update the picker grid.

export const CATEGORIES = [
  { id: 'all',     label: 'All' },
  { id: 'protein', label: 'Protein' },
  { id: 'produce', label: 'Produce' },
  { id: 'dairy',   label: 'Dairy' },
  { id: 'grains',  label: 'Grains' },
  { id: 'pantry',  label: 'Pantry' },
  { id: 'spices',  label: 'Spices' },
];

export const INGREDIENTS = [
  // Protein
  { id: 'chicken_breast', emoji: '🍗', label: 'Chicken Breast', cat: 'protein' },
  { id: 'ground_chicken',  emoji: '🫓', label: 'Ground Chicken',  cat: 'protein' },
  { id: 'ground_turkey',   emoji: '🫓', label: 'Ground Turkey',   cat: 'protein' },
  { id: 'steak',        emoji: '🥩', label: 'Steak',         cat: 'protein' },
  { id: 'ground_beef',   emoji: '🍔', label: 'Ground Beef',   cat: 'protein' },
  { id: 'salmon',     emoji: '🐟', label: 'Salmon',       cat: 'protein' },
  { id: 'haddock',    emoji: '🐟', label: 'Haddock',      cat: 'protein' },
  { id: 'tilapia',    emoji: '🐟', label: 'Tilapia',      cat: 'protein' },
  { id: 'shrimp',     emoji: '🦐', label: 'Shrimp',       cat: 'protein' },
  { id: 'bacon',      emoji: '🥓', label: 'Bacon',        cat: 'protein' },
  { id: 'tofu',       emoji: '🟨', label: 'Tofu',         cat: 'protein' },
  { id: 'tuna',       emoji: '🥫', label: 'Canned Tuna',  cat: 'protein' },
  { id: 'lamb',       emoji: '🥩', label: 'Lamb',         cat: 'protein' },
  { id: 'pork',       emoji: '🥩', label: 'Pork',         cat: 'protein' },
  { id: 'sausage',      emoji: '🌭', label: 'Sausage',       cat: 'protein' },
  { id: 'tempeh',       emoji: '🟫', label: 'Tempeh',        cat: 'protein' },
  { id: 'cod',          emoji: '🐟', label: 'Cod',           cat: 'protein' },
  { id: 'turkey_breast',emoji: '🍗', label: 'Turkey Breast', cat: 'protein' },
  { id: 'deli_ham',     emoji: '🥩', label: 'Ham',           cat: 'protein' },

  // Produce
  { id: 'tomato',     emoji: '🍅', label: 'Tomatoes',     cat: 'produce' },
  { id: 'spinach',    emoji: '🥬', label: 'Spinach',      cat: 'produce' },
  { id: 'broccoli',   emoji: '🥦', label: 'Broccoli',     cat: 'produce' },
  { id: 'carrot',     emoji: '🥕', label: 'Carrot',       cat: 'produce' },
  { id: 'bell_pepper',emoji: '🫑', label: 'Bell Pepper',  cat: 'produce' },
  { id: 'mushroom',   emoji: '🍄', label: 'Mushrooms',    cat: 'produce' },
  { id: 'lemon',      emoji: '🍋', label: 'Lemon',        cat: 'produce' },
  { id: 'avocado',    emoji: '🥑', label: 'Avocado',      cat: 'produce' },
  { id: 'potato',     emoji: '🥔', label: 'Potato',       cat: 'produce' },
  { id: 'corn',       emoji: '🌽', label: 'Corn',         cat: 'produce' },
  { id: 'zucchini',   emoji: '🥒', label: 'Zucchini',     cat: 'produce' },
  { id: 'eggplant',   emoji: '🍆', label: 'Eggplant',     cat: 'produce' },
  { id: 'lettuce',    emoji: '🥬', label: 'Lettuce',      cat: 'produce' },
  { id: 'onion',      emoji: '🧅', label: 'Onion',        cat: 'produce' },
  { id: 'red_onion',  emoji: '🧅', label: 'Red Onion',    cat: 'produce' },
  { id: 'scallions',    emoji: '🌿', label: 'Scallions',     cat: 'produce' },
  { id: 'sweet_potato',  emoji: '🍠', label: 'Sweet Potato',  cat: 'produce' },
  { id: 'asparagus',     emoji: '🥦', label: 'Asparagus',     cat: 'produce' },
  { id: 'cauliflower',   emoji: '🥦', label: 'Cauliflower',   cat: 'produce' },
  { id: 'cucumber',      emoji: '🥒', label: 'Cucumber',      cat: 'produce' },
  { id: 'lime',          emoji: '🍋', label: 'Lime',          cat: 'produce' },
  { id: 'apple',         emoji: '🍎', label: 'Apple',         cat: 'produce' },
  { id: 'mango',         emoji: '🥭', label: 'Mango',         cat: 'produce' },
  { id: 'banana',        emoji: '🍌', label: 'Banana',        cat: 'produce' },

  // Dairy
  { id: 'cheese',     emoji: '🧀', label: 'Cheese',       cat: 'dairy' },
  { id: 'parmesan',   emoji: '🧀', label: 'Parmesan',     cat: 'dairy' },
  { id: 'mozzarella', emoji: '🧀', label: 'Mozzarella',   cat: 'dairy' },
  { id: 'cream',      emoji: '🍶', label: 'Cream',        cat: 'dairy' },
  { id: 'yogurt',        emoji: '🥣', label: 'Yogurt',        cat: 'dairy' },
  { id: 'feta',          emoji: '🧀', label: 'Feta',          cat: 'dairy' },
  { id: 'ricotta',       emoji: '🧀', label: 'Ricotta',       cat: 'dairy' },
  { id: 'sour_cream',    emoji: '🥛', label: 'Sour Cream',    cat: 'dairy' },

  // Grains
  { id: 'pasta',      emoji: '🍝', label: 'Pasta',        cat: 'grains' },
  { id: 'white_rice', emoji: '🍚', label: 'White Rice',   cat: 'grains' },
  { id: 'brown_rice', emoji: '🍚', label: 'Brown Rice',   cat: 'grains' },
  { id: 'bread',      emoji: '🍞', label: 'Bread',        cat: 'grains' },
  { id: 'oats',       emoji: '🌿', label: 'Oats',         cat: 'grains' },
  { id: 'quinoa',     emoji: '🌱', label: 'Quinoa',       cat: 'grains' },
  { id: 'noodles',       emoji: '🍜', label: 'Noodles',        cat: 'grains' },
  { id: 'coconut_flour',  emoji: '🥥', label: 'Coconut Flour',  cat: 'grains' },
  { id: 'almond_flour',   emoji: '🌰', label: 'Almond Flour',   cat: 'grains' },
  { id: 'tortillas',      emoji: '🫓', label: 'Tortillas',      cat: 'grains' },
  { id: 'couscous',       emoji: '🌾', label: 'Couscous',       cat: 'grains' },
  { id: 'polenta',        emoji: '🌽', label: 'Polenta',        cat: 'grains' },

  // Pantry
  { id: 'soy_sauce',      emoji: '🍱', label: 'Soy Sauce',       cat: 'pantry' },
  { id: 'canned_tomato',  emoji: '🥫', label: 'Canned Tomatoes', cat: 'pantry' },
  { id: 'chickpeas',      emoji: '🫘', label: 'Chickpeas',       cat: 'pantry' },
  { id: 'black_beans',  emoji: '🫘', label: 'Black Beans',     cat: 'pantry' },
  { id: 'pinto_beans',  emoji: '🫘', label: 'Pinto Beans',     cat: 'pantry' },
  { id: 'salsa',          emoji: '🥫', label: 'Salsa',           cat: 'pantry' },
  { id: 'honey',          emoji: '🍯', label: 'Honey',           cat: 'pantry' },
  { id: 'coconut_milk',   emoji: '🥥', label: 'Coconut Milk',    cat: 'pantry' },
  { id: 'chicken_broth',  emoji: '🍲', label: 'Chicken Broth',   cat: 'pantry' },
  { id: 'beef_broth',     emoji: '🍲', label: 'Beef Broth',      cat: 'pantry' },
  { id: 'veggie_broth',   emoji: '🍲', label: 'Veggie Broth',    cat: 'pantry' },
  { id: 'lentils',        emoji: '🫜', label: 'Lentils',         cat: 'pantry' },
  { id: 'taco_shells',   emoji: '🌮', label: 'Taco Shells',     cat: 'pantry' },
  { id: 'canned_chili',  emoji: '🥫', label: 'Canned Chili',    cat: 'pantry' },
  { id: 'peanut_butter',  emoji: '🥜', label: 'Peanut Butter',   cat: 'pantry' },
  { id: 'tahini',         emoji: '🫙', label: 'Tahini',          cat: 'pantry' },
  { id: 'tomato_paste',   emoji: '🥫', label: 'Tomato Paste',    cat: 'pantry' },
  { id: 'fish_sauce',     emoji: '🍶', label: 'Fish Sauce',      cat: 'pantry' },
  { id: 'oyster_sauce',   emoji: '🍶', label: 'Oyster Sauce',    cat: 'pantry' },
  { id: 'red_lentils',    emoji: '🫜', label: 'Red Lentils',     cat: 'pantry' },
  { id: 'panko',          emoji: '🍞', label: 'Panko',           cat: 'pantry' },
  { id: 'breadcrumbs',    emoji: '🍞', label: 'Breadcrumbs',     cat: 'pantry' },

  // Spices
  { id: 'chili',       emoji: '🌶️', label: 'Chili',         cat: 'spices' },
  { id: 'cumin',       emoji: '🟤', label: 'Cumin',         cat: 'spices' },
  { id: 'paprika',     emoji: '🫙', label: 'Paprika',       cat: 'spices' },
  { id: 'turmeric',    emoji: '🟡', label: 'Turmeric',      cat: 'spices' },
  { id: 'ginger',      emoji: '🫚', label: 'Ginger',        cat: 'spices' },
  { id: 'cinnamon',    emoji: '🪵', label: 'Cinnamon',      cat: 'spices' },
  { id: 'basil',       emoji: '🌿', label: 'Basil',         cat: 'spices' },
  { id: 'oregano',     emoji: '🌱', label: 'Oregano',       cat: 'spices' },
  { id: 'garlic_powder', emoji: '🫙', label: 'Garlic Powder', cat: 'spices' },
  { id: 'onion_powder',   emoji: '🫙', label: 'Onion Powder',   cat: 'spices' },
  { id: 'rosemary',       emoji: '🌿', label: 'Rosemary',       cat: 'spices' },
  { id: 'thyme',          emoji: '🌿', label: 'Thyme',          cat: 'spices' },
  { id: 'bay_leaves',     emoji: '🌿', label: 'Bay Leaves',     cat: 'spices' },
  { id: 'curry_powder',   emoji: '🟡', label: 'Curry Powder',   cat: 'spices' },
  { id: 'smoked_paprika', emoji: '🫙', label: 'Smoked Paprika', cat: 'spices' },
  { id: 'dried_thyme',    emoji: '🌿', label: 'Italian Herbs',  cat: 'spices' },
];

// All ingredients including staples — used by recipe service and hooks
export const ALL_INGREDIENTS = [...STAPLES, ...INGREDIENTS];
